import styled from 'styled-components'
import { Box } from '../../atoms/Box'

// Re-export shared styles from UI library
export {
  SectionAnalysisTabsContainer as TabsContainer,
  SectionAnalysisTabButton as TabButton,
  SectionAnalysisContentContainer as ContentContainer,
  SectionAnalysisLoadingContainer as LoadingContainer,
  SectionAnalysisErrorContainer as ErrorContainer,
  SectionAnalysisTabContentContainer as TabContentContainer,
  SectionAnalysisMetricsGrid as MetricsGrid,
  SectionAnalysisChartGrid as ChartGrid,
  SectionAnalysisChartContainer as ChartContainer,
  SectionAnalysisChartTitle as ChartTitle,
  SectionAnalysisChartSubtitle as ChartSubtitle,
  SectionAnalysisInsightCard as InsightCard,
  SectionAnalysisInsightTitle as InsightTitle,
  SectionAnalysisInsightText as InsightText,
  SectionAnalysisFilterContainer as FilterContainer,
  SectionAnalysisFilterLabel as FilterLabel,
  SectionAnalysisFilterSelect as FilterSelect,
  SectionAnalysisFilterSection as FilterSection,
  SectionAnalysisFilterBar as FilterBar,
  SectionAnalysisLocationFilters as LocationFilters,
  SectionAnalysisFilterChip as FilterChip,
  SectionAnalysisLocationBadge as LocationBadge,
  SectionAnalysisDivider as Divider,
} from '../../molecules/SectionAnalysisStyles/SectionAnalysisStyles'

// Demographics-specific container
export const DemographicsContainer = styled(Box)`
  width: 100%;
  background: ${({ theme }) => theme.colors.background.primary};
  padding-bottom: 60px;
`
